import React, { useState, useRef, useEffect } from "react";
import video1 from "../src/videos/anupam/01_Main.mp4";
import video2 from "../src/videos/anupam/02_Lifting.mp4";
import video3 from "../src/videos/anupam/03_Steel.mp4";
import video4 from "../src/videos/anupam/04_Cabin.mp4";
import video5 from "../src/videos/anupam/05_E-room.mp4";
import video6a from "../src/videos/anupam/06_a_Case_1_Failure.mp4";
import video6b from "../src/videos/anupam/06_b_Case_2_Failure.mp4";
import video6c from "../src/videos/anupam/06_c_Case_3_Failure .mp4";
import video6d from "../src/videos/anupam/06_d_Case 4 Failurer.mp4";
// import logo from "../src/images/Anupam.svg"
import 'bootstrap/dist/css/bootstrap.min.css';  
import { ReactComponent as Logo } from '../src/images/LOGO with Tagline_ (1) (1).svg';
import { RxCross2 } from "react-icons/rx";
import { Container, Row, Col } from "react-bootstrap";

const videoList = [
  {id: "1", src: video1, label: "Main Hoist Trolley" },
  {id: "2", src: video2, label: "Lifting Beam" },
  {id: "3", src: video3, label: "Steel Structure, Railings, and Stairways" },
  {id: "4", src: video4, label: "Cabin" },
  {id: "5", src: video5, label: "E-Room" },
  {id: "6",  label: "Fail safe gear train mechanism" },
  {id: "6A", src: video6a, label: "Failure of one motor" },
  {id: "6B", src: video6b, label: "Failure of one gear train" },
  {id: "6C", src: video6c, label: "Failure of 3 motors" },
  {id: "6D", src: video6d, label: "Failure of One Wire Rope" },
];


const hotspotPositions = [
  { id: "1", top: "14%", left: "60%" },
  { id: "2", top: "69.1%", left: "61.4%" },
  { id: "3", top: "24%", left: "77%" },
  { id: "4", top: "62%", left: "48%" },
  { id: "5", top: "46%", left: "58%" },
  {id:"", top: "", left: "" },
  { id: "6A", top: "23%", left: "59%" },
  { id: "6B", top: "20%", left: "62%" },
  { id: "6C", top: "12%", left: "65%" },
  { id: "6D", top: "62%", left: "58%" },
];

const VideoHotSpot = () => {
  const [currentVideoIndex, setCurrentVideoIndex] = useState(0);
  const [currentVideoIndexForModal, setCurrentVideoIndexForModal] = useState(0);
  const [videoPausedAtHalf, setVideoPausedAtHalf] = useState(false);
  const [hasInteracted, setHasInteracted] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isVideoPlay, setIsVideoPlay] = useState(false);
  const videoRef = useRef(null);

  useEffect(() => {
    if (videoRef.current) {
      const newVideo = document.createElement("video");
      newVideo.src = videoList[currentVideoIndex].src;
      newVideo.className = "video-render";
      newVideo.muted = true;

      newVideo.onloadeddata = () => {
        videoRef.current.replaceWith(newVideo);
        videoRef.current = newVideo;

        if (hasInteracted) {
          playHalfTime();
        }

        newVideo.onended = () => setVideoPausedAtHalf(false);
        newVideo.onplay = () => setIsVideoPlay(true);
        newVideo.onpause = () => setIsVideoPlay(false);
      };
    }
  }, [currentVideoIndex, hasInteracted]);

  const playHalfTime = () => {
    if (videoRef.current) {
      videoRef.current.play().catch((error) => {
        console.warn("Autoplay prevented:", error);
      });

      videoRef.current.ontimeupdate = () => {
        if (
          videoRef.current.currentTime >= videoRef.current.duration / 2 &&
          !videoPausedAtHalf
        ) {
          videoRef.current.pause();
          setVideoPausedAtHalf(true);
          videoRef.current.ontimeupdate = null;
        }
      };
    }
  };

  const handleVideoChange = (index) => {
    if (index !== currentVideoIndex) {
      setCurrentVideoIndexForModal(index);
      setHasInteracted(true);
      setIsModalOpen(true);
      if (videoPausedAtHalf) {
        videoRef.current.play();
        setVideoPausedAtHalf(false);

        videoRef.current.onended = () => {
          setCurrentVideoIndex(index);
          videoRef.current.onended = null;
        };
      } else {
        setCurrentVideoIndex(index); // Ensure the video changes immediately on first interaction
      }
    }else{
      setCurrentVideoIndexForModal(index);
      setHasInteracted(true);
      setIsModalOpen(true);
      if (videoPausedAtHalf) {
        videoRef.current.play();
        setVideoPausedAtHalf(false);

        videoRef.current.onended = () => {
          setCurrentVideoIndex(index);
          videoRef.current.onended = null;
        };
      }
    }
  };

  function closePopUp() {
    document.querySelector('.side-popup-container').style.display = 'none';
    if (!videoRef.current) {
      setIsModalOpen(false);
      setHasInteracted(false);
      setCurrentVideoIndexForModal(0);
      return;
    }
  
    const video = videoRef.current;
    video.pause(); // Pause to prevent flickering
  
    const playFromHalfway = () => {
      if (video.duration > 0) {
        const halfTime = video.duration / 2; // Get half duration
        video.currentTime = halfTime; // Seek to halfway point
  
        video.onseeked = () => {
          video.muted = true; // Ensure autoplay is allowed
          video.play()
            .then(() => {
              video.muted = false; // Unmute once playing
            })
            .catch((error) => console.warn("Playback error:", error));
  
          video.onseeked = null; // Remove event listener after use
  
          // ✅ **Set modal close delay dynamically**
          setTimeout(() => {
            setIsModalOpen(false);
            setHasInteracted(false);
            setCurrentVideoIndexForModal(0);
            setVideoPausedAtHalf(false);
          }, halfTime * 1000); // Convert seconds to milliseconds
        };
      }
    };
  
    // If metadata is ready, seek immediately; otherwise, wait for it
    if (video.readyState >= 2 && video.duration > 0) {
      playFromHalfway();
    } else {
      video.onloadedmetadata = () => {
        playFromHalfway();
        video.onloadedmetadata = null; // Remove event listener
      };
    }
  }
  
 
  return (
    <Container fluid className="video-wrapper">
    <Row className="header-wpr border-bottom d-flex justify-content-between align-items-center">
        <Col>
          <p className="video-title">Explore our F/G Ladle crane</p>
        </Col>
        <Col className="text-end">
          <Logo className="custom-logo" />
        </Col>
      </Row>
      <Row className="hotspot-wpr">
      <div>
        {/* Sidebar Hotspots */}
        <Col md={2} className="hotspot-container border-end">
          {videoList.map((video, index) => (
            <div key={index} onClick={() => handleVideoChange(index)} className="p-2">
              <p>{video.id}</p>
              <p>{video.label}</p>
            </div>
          ))}
        </Col>
        <Col md={9} className="position-relative">
        {(currentVideoIndexForModal === 0 && isModalOpen) && (
        <div className="side-popup-container">
          {!isVideoPlay &&
          <div onClick={() => closePopUp()} className="cross-icon position-absolute">
            <RxCross2 />
          </div>
          }
          <div className="side-popup">
            <p className="pop-title">Main Hoist Trolley</p>
            <p className="description-title">Description</p>
            <p className="img-description">
            The core lifting mechanism of our ladle crane. This features a four motor 2 planetary gearbox mechanism connected to 2 rope drums, which are connected through Bull Gears and four wire rope reeving system with its core purpose of lifting hot metal ladles or scrap buckets.  
              </p>
              <h3>Features:</h3>
        <ul className="circle-checkmark">
          <li>
             Efficient hoisting
          </li>
          <li>
             Free-fall prevention, 100% mechanical redundant system
          </li>
          <li>
             Silent and smooth hoisting operation
          </li>
        </ul>
          </div>
        </div>)}
        {(currentVideoIndexForModal === 1 && isModalOpen) && (
        <div className="side-popup-container">
         {!isVideoPlay &&
          <div onClick={() => closePopUp()} className="cross-icon">
            <RxCross2 />
          </div>
          }
          <div className="side-popup">
            <p className="pop-title">Lifting Beam</p>
            <p className="description-title">Description</p>
            <p className="img-description">
            We design heavy duty lifting beams capable of withstanding the harsh environment of a steel melting plant 24 hours a day.
              </p>
          </div>
        </div>)}
        {(currentVideoIndexForModal === 2 && isModalOpen) && (
        <div className="side-popup-container">
           {!isVideoPlay &&
          <div onClick={() => closePopUp()} className="cross-icon">
            <RxCross2 />
          </div>
          }
          <div className="side-popup">
            <p className="pop-title">Steel Structure, Railings,and Stairways</p>
            <p className="description-title">Description</p>
            <p className="img-description">
            Our cranes are designed keeping your maintenance requirements in mind allowing for easy and safe access to all maintenance points. Sturdy, rigid, and fatigue resistant structure of our crane further increases the crane’s ergonomics.
              </p>
          </div>
        </div>)}
        {(currentVideoIndexForModal === 3 && isModalOpen) && (
        <div className="side-popup-container">
           {!isVideoPlay &&
          <div onClick={() => closePopUp()} className="cross-icon">
            <RxCross2 />
          </div>
          }
          <div className="side-popup">
            <p className="pop-title">Cabin</p>
            <p className="description-title">Description</p>
            <p className="img-description">
            Equipped with advanced control systems, the operator gains complete control over the crane. Features
              </p>
              <h3>Features:</h3>
              <ul className="circle-checkmark">
          <li>
          Superior visibility. 
          </li>
          <li>  
          Excellent ergonomics. 
          </li>
          </ul>
          </div>
        </div>)}
        {(currentVideoIndexForModal === 4 && isModalOpen) && (
        <div className="side-popup-container">
            {!isVideoPlay &&
          <div onClick={() => closePopUp()} className="cross-icon">
            <RxCross2 />
          </div>
          }
          <div className="side-popup">
            <p className="pop-title">E-Room</p>
            <p className="description-title">Description</p>
            <p className="img-description">
            All of our four girder ladle cranes come equipped with E-rooms and industrial ACs.
              </p>
              <h3>Features:</h3>
              <ul className="circle-checkmark">
          <li>
          Centralized panel access. 
          </li>
          <li>
          Capable of withstanding the harsh steel plant environment.
          </li>
          <li>
          Ease of access and maintenance. 
          </li>
          </ul>
          </div>
        </div>)}
        {(currentVideoIndexForModal === 5 && isModalOpen) && (
        <div className="side-popup-container">
           {!isVideoPlay &&
          <div onClick={() => closePopUp()} className="cross-icon">
            <RxCross2 />
          </div>
          }
          <div className="side-popup">
            <p className="pop-title">Fail safe gear train mechanism</p>
            <p className="description-title">Description</p>
            <p className="img-description">
            We design Main Hoist Mechanism keeping multiple failure scenarios in mind. 
              </p>
          </div>
        </div>)}
        {(currentVideoIndexForModal === 6 && isModalOpen) && (
        <div className="side-popup-container">
           {!isVideoPlay &&
          <div onClick={() => closePopUp()} className="cross-icon">
            <RxCross2 />
          </div>
          }
          <div className="side-popup">
            <p className="pop-title">Failure of one motor</p>
            <p className="description-title">Description</p>
            <p className="img-description">
            The crane will operate with other set of motors at half the rated hoist's speed at 100% load.
              </p>
          </div>
        </div>)}
        {(currentVideoIndexForModal === 7&& isModalOpen) && (
        <div className="side-popup-container">
           {!isVideoPlay &&
          <div onClick={() => closePopUp()} className="cross-icon">
            <RxCross2 />
          </div>
          }
          <div className="side-popup">
            <p className="pop-title">Failure of one gear train</p>
            <p className="description-title">Description</p>
            <p className="img-description">
            If input pinion of one of the Main Hoist Gearbox failed, operation of the load cycle can be completed safely, as rope drums are connected through Bull Gears, without manual release with the help of other side of planetary gearbox and motor. 
              </p>
          </div>
        </div>)}
        {(currentVideoIndexForModal === 8 && isModalOpen) && (
        <div className="side-popup-container">
           {!isVideoPlay &&
          <div onClick={() => closePopUp()} className="cross-icon ">
            <RxCross2 />
          </div>
          }
          <div className="side-popup">
            <p className="pop-title">Failure of 3 motors</p>
            <p className="description-title">Description</p>
            <p className="img-description">
            controlled lowering is possible.   
              </p>
          </div>
        </div>)}
        {(currentVideoIndexForModal === 9 && isModalOpen) && (
        <div className="side-popup-container">
           {!isVideoPlay &&
          <div onClick={() => closePopUp()} className="cross-icon">
            <RxCross2 />
          </div>
          }
          <div className="side-popup">
            <p className="pop-title">Failure of One Wire Rope</p>
            <p className="description-title">Description</p>
            <p className="img-description">
            In case of failure/damage of one wire rope, crane does not stop 
            </p>
          </div>
        </div>)}
</Col>
        <div
          className={'video-container'}
        >
          <video className={"video-render"} ref={videoRef} muted>
            Your browser does not support the video tag.
          </video>
     
        {(!hasInteracted && !videoPausedAtHalf) &&
            hotspotPositions.map((position, index) => (
              <div
                key={index}
                className="hotspot-overlay position-absolute"
                style={{ top: position.top, left: position.left }}
                onClick={() => handleVideoChange((index + 1) - 1)}
              >
                {position.id}
              </div>
            ))}
        </div>
      </div>
      
    </Row>
  </Container>
  );
};

export default VideoHotSpot;
